import {
  Heading,
  Modal,
  ModalContent,
  ModalHeader,
} from '@alefeducation/ui-elements-library-core';
import { Times } from '@alefeducation/ui-elements-library-icons';
import { useState } from 'react';
import styled from 'styled-components';
import { FEATURE_TOGGLE } from '../../utils/FeatureToggle';
import AvatarThumbnail from '../AvatarThumbnail/AvatarThumbnail';

type Props = {
  name: string;
  fileId: string;
};

type noop = () => void;

export const useAvatarInfoModal = ({
  name,
  fileId,
}: Props): [{ open: noop; close: noop }, JSX.Element] => {
  const [isOpen, setIsOpen] = useState(false);
  const modal = {
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };

  const contextHolder = (
    <Modal open={isOpen} size="small" handleBackdropClick={modal.close}>
      <StyledModalHeader>
        <Times
          height="14"
          width="14"
          color="primary.40"
          onClick={modal.close}
          cursor="pointer"
        />
      </StyledModalHeader>
      <ModalContent>
        <ModalBody>
          <AvatarThumbnail
            name={name}
            src={`${FEATURE_TOGGLE.FILE_SERVICE_CDN}${fileId}`}
          />
          <Heading variant="heading-small" weight="bold" color="primary.100">
            {name}
          </Heading>
        </ModalBody>
      </ModalContent>
    </Modal>
  );

  return [modal, contextHolder];
};

const StyledModalHeader = styled(ModalHeader)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 24px;

  img {
    height: 200px;
    width: 200px;
  }
`;
